/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Reset type for the charger.
 */
export var ResetType;
(function (ResetType) {
    ResetType["HARD"] = "HARD";
})(ResetType || (ResetType = {}));
